(() => {
  'use strict';
  if (window.AWEcosystemP1ContextRelay?.version) return;

  const normalize = (value = '') => String(value || '').trim().toLowerCase().normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '').replace(/&/g, ' et ').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const list = (value = '') => String(value || '').split(',').map((item) => item.trim()).filter(Boolean);
  const bridge = () => window.AWEcosystemP1Bridge || null;
  const activeReplica = () => bridge()?.activeReplica?.() || null;
  const currentContext = () => {
    try { return window.AWAirsoftContext?.current?.() || JSON.parse(localStorage.getItem('aw_airsoft_context_v1') || '{}'); }
    catch (_) { return {}; }
  };
  const recordFromNode = (node) => node ? {
    handle: String(node.dataset.handle || '').trim(),
    label: String(node.dataset.label || '').trim(),
    model: String(node.dataset.model || '').trim(),
    manufacturer: String(node.dataset.manufacturer || '').trim(),
    platform: String(node.dataset.platform || '').trim(),
    platformLabel: String(node.dataset.platformLabel || '').trim(),
    type: String(node.dataset.type || '').trim(),
    pageUrl: String(node.dataset.pageUrl || '').trim(),
    workshopServices: list(node.dataset.workshopServices)
  } : null;
  const recordByHandle = (handle) => {
    const wanted = String(handle || '').trim();
    if (!wanted) return null;
    const node = Array.from(document.querySelectorAll('[data-aw-tool-model],[data-aw-model-context-model]'))
      .find((item) => String(item.dataset.handle || '').trim() === wanted);
    return recordFromNode(node);
  };
  const exactFromContext = () => {
    const requested = new URLSearchParams(location.search).get('aw_model') || '';
    const direct = recordByHandle(requested);
    if (direct) return direct;

    const current = currentContext();
    if ((!current?.model && !current?.modelLabel) || !bridge()?.resolveExactModel) return null;
    return bridge().resolveExactModel({
      manufacturer: current.manufacturerLabel || current.manufacturer || '',
      model: current.model || current.modelLabel || '',
      platform: current.platform || '',
      type: current.type || current.replicaType || ''
    });
  };
  const currentRecord = () => {
    const replica = activeReplica();
    if (replica && bridge()?.resolveExactModel) return bridge().resolveExactModel(replica);
    return exactFromContext();
  };
  const recordLabel = (record) => String(record?.label || [record?.manufacturer, record?.model].filter(Boolean).join(' ') || record?.model || 'Modèle exact AW').trim();
  const exactUrl = (base, record, source = 'ecosystem') => {
    if (!base || !record?.handle) return base || '';
    try {
      const url = new URL(base, location.origin);
      url.searchParams.set('aw_model', record.handle);
      if (!url.searchParams.has('aw_from')) url.searchParams.set('aw_from', source);
      return `${url.pathname}${url.search}${url.hash}`;
    } catch (_) { return base; }
  };
  const serviceHandleFromLink = (link) => {
    try { return String(new URL(link.href, location.origin).pathname.match(/^\/products\/([^/?#]+)/i)?.[1] || '').trim(); }
    catch (_) { return ''; }
  };
  const serviceCard = (_root, handle) => {
    const wanted = normalize(handle);
    if (!wanted) return null;
    const explicit = Array.from(document.querySelectorAll('[data-aw-service-handle]'))
      .find((node) => normalize(node.dataset.awServiceHandle || '') === wanted);
    if (explicit) return explicit.closest('.aw14-card') || explicit;
    const link = Array.from(document.querySelectorAll('a[href*="/products/"]'))
      .find((item) => normalize(serviceHandleFromLink(item)) === wanted);
    return link?.closest('.aw14-card') || null;
  };
  const removeRelayMarks = (root) => {
    document.querySelectorAll('.aw14-card[data-aw-workshop-match="exact-context"]').forEach((card) => {
      card.classList.remove('is-aw-active-service');
      delete card.dataset.awWorkshopMatch;
      card.querySelectorAll('[data-aw-context-relay-service-note]').forEach((note) => note.remove());
    });
    root?.querySelector('[data-aw-ecosystem-context-relay-atelier]')?.remove();
  };
  const removeTypeFallback = (_root) => {
    document.querySelectorAll('.aw14-card[data-aw-workshop-match="type"]').forEach((card) => {
      card.classList.remove('is-aw-active-service');
      delete card.dataset.awWorkshopMatch;
      card.querySelectorAll('[data-aw-active-service-note]').forEach((note) => note.remove());
    });
  };

  const renderAtelier = () => {
    const root = document.querySelector('#aw-atelier-hub');
    if (!root) return;
    removeRelayMarks(root);
    if (activeReplica()) return;

    const record = exactFromContext();
    if (!record) return;
    const handles = Array.isArray(record.workshopServices) ? record.workshopServices.filter(Boolean) : list(record.workshopServices);
    if (handles.length) removeTypeFallback(root);

    let visible = 0;
    handles.forEach((handle) => {
      const card = serviceCard(root, handle);
      if (!card) return;
      visible += 1;
      card.classList.add('is-aw-active-service');
      card.dataset.awWorkshopMatch = 'exact-context';
      if (!card.querySelector('[data-aw-context-relay-service-note]')) {
        const note = document.createElement('p');
        note.dataset.awContextRelayServiceNote = 'true';
        note.className = 'aw-ecosystem-p1-service-note';
        note.textContent = 'Relation Atelier enregistrée pour le modèle exact actuellement sélectionné dans Compatibility. Vérifiez le périmètre et la configuration réelle avant intervention.';
        const footer = card.querySelector('.aw14-card__footer');
        if (footer) footer.before(note);
        else card.append(note);
      }
    });

    const services = root.querySelector('#aw-atelier-prestations');
    if (!services) return;
    const note = document.createElement('div');
    note.dataset.awEcosystemContextRelayAtelier = 'true';
    note.className = 'aw-ecosystem-p1-service-note';
    const label = recordLabel(record);
    note.textContent = handles.length
      ? `Contexte Compatibility conservé : ${label} · ${handles.length} prestation${handles.length > 1 ? 's' : ''} Atelier explicitement liée${handles.length > 1 ? 's' : ''} dans Shopify · ${visible} affichée${visible > 1 ? 's' : ''} sur cette page. Ce contexte n’est pas ajouté automatiquement à AW Garage.`
      : `Contexte Compatibility conservé : ${label}. Aucune prestation Atelier spécifique n’est actuellement enregistrée pour ce modèle exact. Ce contexte n’est pas ajouté automatiquement à AW Garage.`;
    services.prepend(note);
  };

  const renderMonAtelier = () => {
    const root = document.querySelector('[data-aw-atelier]');
    const hero = root?.querySelector('.aw-atelier__hero');
    if (!root || !hero) return;
    const panel = root.querySelector('[data-aw-ecosystem-mon-atelier-status]');
    let note = root.querySelector('[data-aw-ecosystem-context-relay-mon-atelier]');
    if (activeReplica()) { note?.remove(); return; }
    const record = exactFromContext();
    if (!record) { note?.remove(); return; }
    if (!note) {
      note = document.createElement('aside');
      note.dataset.awEcosystemContextRelayMonAtelier = 'true';
      note.className = 'aw-ecosystem-p1-context aw-ecosystem-p1-context--compatibility-relay';
      (panel || hero).insertAdjacentElement('afterend', note);
    } else if (panel && note.previousElementSibling !== panel) {
      panel.insertAdjacentElement('afterend', note);
    }
    note.replaceChildren();
    const copy = document.createElement('div');
    copy.className = 'aw-ecosystem-p1-context__copy';
    const eyebrow = document.createElement('span');
    eyebrow.className = 'aw-ecosystem-p1-context__eyebrow';
    eyebrow.textContent = 'CONTEXTE COMPATIBILITY';
    const title = document.createElement('strong');
    title.className = 'aw-ecosystem-p1-context__title';
    title.textContent = recordLabel(record);
    const meta = document.createElement('span');
    meta.className = 'aw-ecosystem-p1-context__meta';
    const count = Array.isArray(record.workshopServices) ? record.workshopServices.length : list(record.workshopServices).length;
    meta.textContent = `${count} prestation${count > 1 ? 's' : ''} Atelier explicitement liée${count > 1 ? 's' : ''} dans Shopify · contexte séparé d’AW Garage tant qu’aucune fiche Garage n’est activée.`;
    copy.append(eyebrow, title, meta);
    const actions = document.createElement('div');
    actions.className = 'aw-ecosystem-p1-context__actions';
    const compatibility = document.createElement('a');
    compatibility.className = 'aw-ecosystem-p1-link';
    compatibility.href = record.pageUrl || exactUrl('/pages/compatibilite-airsoft', record, 'mon-atelier');
    compatibility.textContent = record.pageUrl ? 'Ouvrir la fiche Compatibility' : 'Retour à Compatibility';
    const atelier = document.createElement('a');
    atelier.className = 'aw-ecosystem-p1-link';
    atelier.href = exactUrl('/pages/notre-atelier-de-preparation-de-repliques-airsoft#aw-atelier-prestations', record, 'mon-atelier');
    atelier.textContent = 'Voir les prestations Atelier';
    actions.append(compatibility, atelier);
    note.append(copy, actions);
  };

  const decorateRelayLinks = () => {
    const record = currentRecord();
    if (!record?.handle) return 0;
    const selectors = [
      '[data-aw-ecosystem-context] a[href]',
      '[data-aw-ecosystem-context-relay-mon-atelier] a[href]',
      '.aw14-actions a[href]',
      '[data-aw-ecosystem-mon-atelier-status] a[href]'
    ].join(',');
    const allowed = new Set([
      '/pages/compatibilite-airsoft',
      '/pages/mon-atelier-airsoft',
      '/pages/notre-atelier-de-preparation-de-repliques-airsoft',
      '/pages/configurateur-airsoft'
    ]);
    let changed = 0;
    document.querySelectorAll(selectors).forEach((link) => {
      try {
        const url = new URL(link.href, location.origin);
        if (!allowed.has(url.pathname)) return;
        if (url.pathname === '/pages/compatibilite-airsoft' && record.pageUrl) {
          const published = new URL(record.pageUrl, location.origin);
          link.href = `${published.pathname}${published.search}${published.hash}`;
          link.dataset.awExactContextLink = 'published-page';
          changed += 1;
          return;
        }
        url.searchParams.set('aw_model', record.handle);
        if (!url.searchParams.has('aw_from')) url.searchParams.set('aw_from', 'ecosystem');
        link.href = `${url.pathname}${url.search}${url.hash}`;
        link.dataset.awExactContextLink = 'query';
        changed += 1;
      } catch (_) {}
    });
    return changed;
  };

  let scheduled = false;
  const render = () => {
    if (scheduled) return;
    scheduled = true;
    setTimeout(() => {
      scheduled = false;
      renderAtelier();
      renderMonAtelier();
      decorateRelayLinks();
    }, 0);
  };

  window.addEventListener('aw:context-changed', render);
  window.addEventListener('aw:compatibility-changed', render);
  window.addEventListener('aw:garage-context-changed', render);
  window.addEventListener('aw:model-index-ready', render);
  window.addEventListener('storage', (event) => {
    if (['aw_airsoft_context_v1', 'aw_garage_active_replica_v1', 'aw_garage_replicas_v1'].includes(event.key)) render();
  });
  document.addEventListener('shopify:section:load', render);

  if ('MutationObserver' in window) {
    let pending = false;
    new MutationObserver((mutations) => {
      if (pending || !mutations.some((mutation) => mutation.addedNodes?.length)) return;
      pending = true;
      requestAnimationFrame(() => {
        pending = false;
        decorateRelayLinks();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  window.AWEcosystemP1ContextRelay = {
    version: '1.1.1',
    render,
    exactFromContext,
    currentRecord,
    exactUrl,
    renderAtelier,
    renderMonAtelier,
    decorateRelayLinks,
    policy: 'compatibility-context-never-creates-garage-record;page-wide-exact-service-matching;exact-model-url-relay'
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render, { once: true });
  else render();
})();
